import React from 'react'

import { Icon, Tooltip } from '@fourthwall/components'
import { TickIcon } from '@fourthwall/icons'

import * as S from './styled'

type Props = {
  emoji: string
  text: string
  borderColor?: string
  backgroundColor?: string
  textColor?: string
  verified?: boolean
  iconOnly?: boolean
}

export const Badge = ({
  emoji,
  text,
  borderColor,
  backgroundColor,
  textColor,
  verified,
  iconOnly,
}: Props) => {
  const getEmoji = () => {
    if (emoji.startsWith('http')) {
      return <S.Image src={emoji} alt="emoji" iconOnly={iconOnly} />
    }

    return <S.Emoji iconOnly={iconOnly}>{emoji}</S.Emoji>
  }

  if (verified) {
    return (
      <Tooltip
        reference={
          <S.VerifiedBadge style={{ borderColor, backgroundColor, color: textColor }}>
            <Icon component={TickIcon} height={10} />
          </S.VerifiedBadge>
        }
        placement="top"
      >
        {text}
      </Tooltip>
    )
  }

  if (iconOnly) {
    return (
      <Tooltip reference={getEmoji()} placement="top">
        {text}
      </Tooltip>
    )
  }

  return (
    <S.Badge style={{ borderColor, backgroundColor, color: textColor }}>
      {getEmoji()} <S.Text>{text}</S.Text>
    </S.Badge>
  )
}
